// studentService.js
import apiClient from '../api/api';

const studentService = {
  // Get student by ID (basic info)
  getStudentById: async (studentId) => {
    try {
      console.log('StudentService: getStudentById', studentId);
      const response = await apiClient.get(`/students/${studentId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching student by ID:', error);
      throw error;
    }
  },
  
  // Get student profile data by student ID (keeping for backward compatibility)
  getStudentProfile: async (studentId) => {
    try {
      console.log('StudentService: getStudentProfile', studentId);
      const response = await apiClient.get(`/students/${studentId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching student profile:', error);
      throw error;
    }
  },

  // Get student assignments by student ID
  getStudentAssignments: async (studentId, params = {}) => {
    try {
      console.log('StudentService: getStudentAssignments', studentId);
      // Match the mobile implementation
      const response = await apiClient.get(`/assignments/by-student/${studentId}`, { params });
      return response.data;
    } catch (error) {
      // Follow the mobile pattern of handling parent-specific endpoints
      if (error.response && error.response.status === 403) {
        try {
          console.log('Attempting parent-specific assignment access');
          const parentResponse = await apiClient.get(`/parents/children/${studentId}/assignments`);
          
          if (parentResponse.data && parentResponse.data.data) {
            return parentResponse.data.data;
          } else {
            return [];
          }
        } catch (parentError) {
          console.error(`Parent access error for assignments:`, parentError);
          return [];
        }
      }
      
      console.error('Error fetching student assignments:', error);
      return []; // Return empty array as fallback
    }
  },

  // Get student attendance by student ID
  getStudentAttendance: async (studentId, params = {}) => {
    try {
      console.log('StudentService: getStudentAttendance', studentId);
      const response = await apiClient.get(`/students/${studentId}/attendance`, { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching student attendance:', error);
      throw error;
    }
  },

  // Update student notes
  updateStudentNotes: async (studentId, notes) => {
    try {
      console.log('StudentService: updateStudentNotes', studentId);
      const response = await apiClient.put(`/students/${studentId}/notes`, { notes });
      return response.data;
    } catch (error) {
      console.error('Error updating student notes:', error);
      throw error;
    }
  },

  // Get student stats 
  getStudentStats: async (studentId) => {
    try {
      console.log('StudentService: getStudentStats', studentId);
      const response = await apiClient.get(`/students/${studentId}/stats`);
      return response.data;
    } catch (error) {
      console.error('Error fetching student stats:', error);
      // Return default stats values to match mobile fallback behavior
      return {
        assignmentCompletion: 0,
        assessmentAverage: 0,
        attendanceRate: 0
      };
    }
  },

  // Get student progress (consistent with mobile implementation)
  getStudentProgress: async (studentId) => {
    try {
      console.log('StudentService: getStudentProgress', studentId);
      const response = await apiClient.get(`/students/${studentId}/progress`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching progress for student ${studentId}:`, error);
      // Return default values to match mobile implementation
      return {
        attendancePercentage: 0,
        juzComplete: 0,
        surComplete: 0
      };
    }
  },

  // Create a new assignment for a student
  createAssignmentForStudent: async (studentId, assignmentData) => {
    try {
      console.log('StudentService: createAssignmentForStudent', studentId);
      const response = await apiClient.post(`/assignments/student/${studentId}`, assignmentData);
      return response.data;
    } catch (error) {
      console.error('Error creating assignment for student:', error);
      throw error;
    }
  },

  // Get parent information for a student
  getStudentParents: async (studentId) => {
    try {
      console.log('StudentService: getStudentParents', studentId);
      const response = await apiClient.get(`/students/${studentId}/parents`);
      return response.data;
    } catch (error) {
      console.error('Error fetching student parents:', error);
      throw error;
    }
  }
};

export default studentService;